import { ZodError } from 'zod'

export function getErrorLogMessage(error: Error): string
export function getErrorLogMessage(
  error: unknown,
  fallbackMessage: string
): string
export function getErrorLogMessage(
  error: Error | unknown,
  fallbackMessage?: string
) {
  if (!(error instanceof Error)) {
    return getOtherLogMessage(error, fallbackMessage ?? 'Unknown error')
  }

  const getInnerError = (outer: Error) => {
    if (outer.cause instanceof Error) {
      return getInnerError(outer.cause)
    }
    return outer
  }

  const inner = getInnerError(error)

  return inner === error ? error.message : `${error.message} (${inner.message})`
}

const getOtherLogMessage = (error: unknown, fallbackMessage: string) => {
  if (typeof error === 'string') {
    return error
  }

  if (error instanceof Error || error instanceof ZodError) {
    return error.message
  }

  return fallbackMessage
}
